<!-- Quick stats boxes -->
<div class="row">
    <div class="col-lg-3">

        <!-- Members online -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">{{ekub.value}}</h3>
                <strong>Total Value</strong>
                <div class="text-size-small"> {{ekub.amount}} ETB / {{getInterval(this.ekub.interval)}}</div>
            </div>

            <div class="container-fluid">
                <div id="members-online"></div>
            </div>
        </div>
        <!-- /members online -->

    </div>

    <div class="col-lg-3">

        <!-- Current server load -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">{{ekub.awardValue}}</h3>
                <strong>Award Value</strong>
                <div class="text-size-small"> Starting on {{getInterval(this.ekub.interval)}} {{ekub.firstAwardOn}}
                </div>
            </div>

            <div id="server-load"></div>
        </div>
        <!-- /current server load -->

    </div>

    <div class="col-lg-3">

        <!-- Today's revenue -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">0</h3>
                <strong>Total Surplus</strong>
                <div class="text-size-small">0 Rounds - 0.00 ETB</div>
            </div>

            <div id="today-revenue"></div>
        </div>
        <!-- /today's revenue -->

    </div>


    <div class="col-lg-3">

        <!-- Today's revenue -->
        <div class="panel bg-light-700">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">0</h3>
                <strong>Total Deficit</strong>
                <div class="text-size-small">0 Rounds - 0.00 ETB</div>
            </div>

            <div id="today-revenue"></div>
        </div>
        <!-- /today's revenue -->

    </div>

</div>
<!-- /quick stats boxes -->

<div class="row">

    <div class="col-md-8">
        <!-- Marketing campaigns -->
        <div style="padding:15px;" class="panel panel-flat">
            <div class="content-group">



                <div class="table-responsive">
                    <table class="table table-striped text-nowrap table-customers">
                        <thead>
                            <tr>
                                <th>Round</th>
                                <th>Balance Before</th>
                                <th>Balance After</th>
                                <th>Awards Remaining</th>
                                <th>Current Balance</th>
                                <th>Difference</th>
                                <th>Status</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let round of rounds">
                                <td>
                                    <div class="media">
                                        <div class="media-body media-middle">
                                            <a href="" class="text-semibold">
                                                {{round?.round}}</a>
                                            <div class="text-muted text-size-small">
                                                {{ekub.amount}} ETB / {{ekub?.interval}}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <th>{{round?.balanceBefore}} ETB</th>
                                <td>{{round?.balanceAfter}} ETB</td>
                                <td>{{round?.awardsRemaining}}</td>
                                <td>{{ekub?.startDate?.start_date|date:short}}</td>
                                <td>{{ekub?.endDate|date:short}}</td>
                                <!-- <td>
                                    <ul class="list list-unstyled no-margin">
                                        <li class="no-margin">
                                            <i class="icon-checkmark3 text-size-base text-success position-left"></i>
                                            Due:
                                            <a href="#">{{ekub?.ekub_balance_due|number:'1.2-2'}} ETB</a>
                                        </li>
                                        <li class="no-margin">
                                            <i class="text-size-base position-left"
                                                [ngClass]="{'text-success-400 icon-checkmark3':(ekub?.ekub_balance >=ekub?.ekub_balance_due),'text-warning icon-cross2':(ekub?.ekub_balance < ekub?.ekub_balance_due)}"></i>
                                            Balance:
                                            <a href="#">{{ekub?.ekub_balance|number:'1.2-2'}} ETB</a>
                                        </li>


                                    </ul>
                                </td> -->
                                <td class="no-padding-left"></td>
                            </tr>

                        </tbody>
                    </table>
                </div>

            </div>

        </div>
    </div>

    <div class="col-md-4">

        <div style="padding:15px;" class="panel panel-flat">
            <div class="content-group">

                <div class="col-md-12">
                    <div class="form-group required">
                        <span class="control-label">Start Date: </span>
                        <input type="date" name="start_date" [(ngModel)]="ekub.startDate" #startDate="ngModel"
                            placeholder="ekub start date" class="form-control">

                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group required">
                        <span class="control-label">End Date: </span>
                        <input type="date" name="endDate" [(ngModel)]="ekub.endDate" #endDate="ngModel"
                            placeholder="ekub end date" class="form-control">
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group required">
                        <span class="control-label">Type: </span>
                        <ng-select [items]="intervals" placeholder="" name="branch" [(ngModel)]="ekub.interval"
                            #intervalControl="ngModel" bindValue="value" bindLabel="name" required>
                        </ng-select>
                    </div>
                </div>


                <div class="col-md-12">
                    <div class="form-group required">
                        <span class="control-label">Amount: </span>
                        <input type="number" name="amount" [(ngModel)]="ekub.amount" #amountControl="ngModel"
                            placeholder="ekub amount" class="form-control">
                    </div>
                </div>


                <div class="col-md-12">
                    <div class="form-group required">
                        <span class="control-label">Members Count: </span>
                        <input type="number" name="membersCount" [(ngModel)]="ekub.membersCount" #countControl="ngModel"
                            placeholder="ekub members count" class="form-control">
                    </div>
                </div>





                <div class="col-md-12">
                    <div class="form-group required">
                        <span class="control-label">First Awards: </span>
                        <input type="number" name="firstAwards" [(ngModel)]="ekub.firstAwards"
                            #firstAwardsControl="ngModel" placeholder="ekub first award count" class="form-control">
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group required">
                        <span class="control-label">First Award on: </span>
                        <input type="number" name="firstAwardOn" [(ngModel)]="ekub.firstAwardOn"
                            (change)="initiateSimulator()" #firstAwardOnControl="ngModel"
                            placeholder="ekub first award round" class="form-control">
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>